import * as xlsx from '@e965/xlsx';
import { downloadFromBlob } from '../blob-util';
import { Downloader } from '../interfaces/downloader.interface';

export class XlsxDownloader implements Downloader {
  /**
   * The name of the file to be downloaded, excluding the extension.
   */
  private readonly fileName: string;

  /**
   * The name of the Excel sheet.
   */
  private readonly sheetName: string;

  /**
   * @param fileName
   * @param sheetName
   */
  constructor(
    fileName: string,
    sheetName: string
  ) {
    this.fileName = fileName.endsWith('.xlsx') ? fileName : `${fileName}.xlsx`;
    this.sheetName = sheetName;
  }

  /**
   * Downloads an XLSX file.
   *
   * @param headers
   * @param rows
   */
  download(headers: string[], rows: string[][]): void {
    try {
      const workBook: xlsx.WorkBook = this.createWorkbook(headers, rows);
      const data: BlobPart = xlsx.write(workBook, {bookType: 'xlsx', type: 'array'});

      downloadFromBlob(
        this.fileName,
        [data],
        {type: 'application/octet-stream'}
      );
    } catch (error) {
      console.error('Error downloading XLSX file:', error);
    }
  }

  /**
   * Creates a workbook with the provided rows.
   *
   * @param headers
   * @param rows
   */
  private createWorkbook(headers: string[], rows: string[][]): xlsx.WorkBook {
    const workBook: xlsx.WorkBook = xlsx.utils.book_new();

    if (headers.length > 0) {
      rows = [...[headers], ...rows];
    }

    const workSheet: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet(rows);
    xlsx.utils.book_append_sheet(workBook, workSheet, this.sheetName);

    return workBook;
  }
}
